import heroData from "@/data/hero.json";

export function useHeroData() {
  return { heroData };
}